import { Role } from '@app/services';
import { Address } from './address';
import { Customer } from './customer';
import { Deserializable } from './deserializable';
import { Operation } from './operation';
import { Organization } from './organization';

export class User implements Deserializable {
  id: number;
  name: string;
  email: string;
  username: string;

  roles: Role[];

  cpfCnpj: string;
  type: string;
  token: string;
  refreshToken: string;
  tokenExpiry: number;

  changePassword: boolean;

  operations: Operation[];

  profiles: string[];
  customer: Customer;

  operationsId: number[];
  customerId: number;
  address: Address;

  segmentOperations?: any[];

  userType: string;

  organizations: Organization[];

  segmentOperationIds: number[];

  deserialize(input: User): this {
    Object.assign(this, input);
    return this;
  }
}

export enum Profiles {
  ADMIN = 'Administrador',
  GERENTE_ATENDIMENTO = 'Gerente de Atendimento',
  GERENTE_QUALIDADE = 'Gerente de Qualidade',
  GERENTE_OPERACAO = 'Gerente de Operação',
  SUPERVISOR_QUALIDADE = 'Supervisor de Qualidade',
  SUPERVISOR_OPERACAO = 'Supervisor de Operação',
  OPERADOR = 'Operador',
  INSTRUTOR = 'Instrutor',
  MONITOR = 'Monitor',
  ANALISTA_MIS = 'Analista Mis',
  ANALISTA_ATENDIMENTO = 'Analista de Atendimento',
}
